import React from 'react'
import Price from '../../PositionColumns/Price'
import PnlPrice from '../../PositionColumns/PnlPrice'
import UserTag from '../../UserTag'
import EntryTime from '../../PositionColumns/EntryTime'
import { Tag } from 'antd'
import SettingSaveInput from '../SettingSaveInput'

export const column_setting = (mutate, onClick) => {
	return [
		{
			title: '설정키',
			dataIndex: 'type',
			key: 'type',
			width: 200,
			render: (text, record) => (
				<>
					{record?.key == 'SEC' ? (
						<Tag>
							{record?.key == 'SEC' ? '보안프로그램패스' : ''}
						</Tag>
					) : (
						<>
							<Tag>{text}</Tag>
							<Tag>
								{record?.key == 'PPT'
									? '청산방지타임'
									: record?.key}
							</Tag>
						</>
					)}
				</>
			),
		},
		{
			title: '세팅값',
			dataIndex: 'value',
			key: 'value',
			render: (text, record) => {
				return <SettingSaveInput data={record} mutate={mutate} />
			},
		},
	]
}
